var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MainContent"},[_c('div',{staticClass:"cards_"},[_vm._t("cards")],2),_c('div',{staticClass:"chart"},[_vm._t("chart_year"),_vm._t("chart_month"),_vm._t("chart_day")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }